import { render, staticRenderFns } from "./flowpanel.vue?vue&type=template&id=96ae1a78&"
import script from "./flowpanel.vue?vue&type=script&lang=ts&"
export * from "./flowpanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96ae1a78')) {
      api.createRecord('96ae1a78', component.options)
    } else {
      api.reload('96ae1a78', component.options)
    }
    module.hot.accept("./flowpanel.vue?vue&type=template&id=96ae1a78&", function () {
      api.rerender('96ae1a78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/flowpanel.vue"
export default component.exports